import { ApiBaseService } from 'api/apibase.service';
import { Locale } from 'enums/locale';
import { OrderConfirmation } from 'redux/order-confirmation/types/types';
import { getCartNgUrl } from 'utils/cart-validation/cart-region-validation';
import Cookies from 'js-cookie';
import axios, { AxiosPromise } from 'axios';

class OrderConfirmationApiService extends ApiBaseService {
  findByRegion(saleToken: string, region: number): Promise<OrderConfirmation> {
    const url = getCartNgUrl(region);
    const locale =
      Cookies.get('locale') === Locale.FR_CA ? Locale.FR_CA : Locale.EN_US;
    if (!url) {
      throw new Error('Invalid URL for CartNG');
    }
    if (!saleToken) {
      throw new Error('Missing sale token for order confirmation request');
    }
    return axios
      .get<OrderConfirmation>(
        `${url}/cart/order-confirmation/sale-details/v2?saleToken=${encodeURIComponent(
          saleToken,
        )}&locale=${locale}`,
      )
      .then(({ data }) => data);
  }

  removeCountryCode(phoneNumber: string): string {
    if (phoneNumber.startsWith('+1')) {
      return phoneNumber.slice(2);
    }
    return phoneNumber;
  }

  checkPhoneNumberExists(phoneNumber: string): AxiosPromise<number> {
    const cleanNumber = this.removeCountryCode(phoneNumber);
    return this.apibase.get<number>(
      `/orders/check-phone-number-exists/${cleanNumber}`,
    );
  }
}
const orderConfirmationApiService = new OrderConfirmationApiService();

export { orderConfirmationApiService };
